import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import PlayerProfile from './pages/PlayerProfile';
import Messages from './pages/Messages';
import Calendar from './pages/Calendar';
import Documents from './pages/Documents';
import News from './pages/News';
import ReportInjury from './pages/ReportInjury';
import CareerUpdate from './pages/CareerUpdate';
import MonthlyCheckIn from './pages/MonthlyCheckIn';
import Alerts from './pages/Alerts';
import ResourceLibrary from './pages/ResourceLibrary';
import PlayerFormPage from './pages/PlayerFormPage';
import BookDownloads from './pages/BookDownloads';
import UserManagement from './pages/UserManagement';
import UpgradeAccount from './pages/UpgradeAccount';
import AdminSetup from './pages/AdminSetup';
import IkonsPlayerDashboard from './pages/IkonsPlayerDashboard';
import IkonsPreMatch from './pages/IkonsPreMatch';
import IkonsPostMatch from './pages/IkonsPostMatch';
import IkonsWeek from './pages/IkonsWeek';
import IkonsAdminPanel from './pages/IkonsAdminPanel';
import IkonsAdminPlayerDetail from './pages/IkonsAdminPlayerDetail';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check URL fragment synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login/staff" element={<Login />} />
      <Route path="/admin-setup" element={<AdminSetup />} />
      
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      
      <Route path="/profile" element={
        <ProtectedRoute>
          <PlayerProfile />
        </ProtectedRoute>
      } />
      
      <Route path="/messages" element={
        <ProtectedRoute>
          <Messages />
        </ProtectedRoute>
      } />
      
      <Route path="/calendar" element={
        <ProtectedRoute>
          <Calendar />
        </ProtectedRoute>
      } />
      
      <Route path="/documents" element={
        <ProtectedRoute>
          <Documents />
        </ProtectedRoute>
      } />
      
      <Route path="/news" element={
        <ProtectedRoute>
          <News />
        </ProtectedRoute>
      } />
      
      <Route path="/report-injury" element={
        <ProtectedRoute>
          <ReportInjury />
        </ProtectedRoute>
      } />
      
      <Route path="/career-update" element={
        <ProtectedRoute>
          <CareerUpdate />
        </ProtectedRoute>
      } />
      
      <Route path="/monthly-checkin" element={
        <ProtectedRoute>
          <MonthlyCheckIn />
        </ProtectedRoute>
      } />
      
      <Route path="/alerts" element={
        <ProtectedRoute>
          <Alerts />
        </ProtectedRoute>
      } />
      
      <Route path="/resources" element={
        <ProtectedRoute>
          <ResourceLibrary />
        </ProtectedRoute>
      } />
      
      <Route path="/player-form" element={
        <ProtectedRoute>
          <PlayerFormPage />
        </ProtectedRoute>
      } />
      
      <Route path="/book-downloads" element={
        <ProtectedRoute>
          <BookDownloads />
        </ProtectedRoute>
      } />
      
      <Route path="/user-management" element={
        <ProtectedRoute>
          <UserManagement />
        </ProtectedRoute>
      } />
      
      <Route path="/upgrade-account" element={
        <ProtectedRoute>
          <UpgradeAccount />
        </ProtectedRoute>
      } />
      
      {/* IKONS Player System Routes */}
      <Route path="/ikons" element={
        <ProtectedRoute>
          <IkonsPlayerDashboard />
        </ProtectedRoute>
      } />
      
      <Route path="/ikons/pre-match" element={
        <ProtectedRoute>
          <IkonsPreMatch />
        </ProtectedRoute>
      } />
      
      <Route path="/ikons/post-match" element={
        <ProtectedRoute>
          <IkonsPostMatch />
        </ProtectedRoute>
      } />
      
      <Route path="/ikons/week" element={
        <ProtectedRoute>
          <IkonsWeek />
        </ProtectedRoute>
      } />
      
      <Route path="/ikons/admin" element={
        <ProtectedRoute>
          <IkonsAdminPanel />
        </ProtectedRoute>
      } />
      
      <Route path="/ikons/admin/player/:playerId" element={
        <ProtectedRoute>
          <IkonsAdminPlayerDetail />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;